import Solver from './solver'
import { getBoxIndicies } from '../utils'
import { SolverNames } from '../constants'

export default class BoxSolver extends Solver {
  getName () {
    return SolverNames.BOX_SOLVER
  }

  runSolver () {
    const indicies = getBoxIndicies(this.solvingSpot)
    const cells = indicies.map((i) => this.puzzle[i[1]][i[0]])
    return this.solveVals(cells)
  }

  isSolving (x: number, y: number): boolean {
    const indicies = getBoxIndicies(this.solvingSpot)
    return indicies.some((i) => i[0] === x && i[1] === y)
  }

  isComplete (solvingSpot: number): boolean {
    const indicies = getBoxIndicies(solvingSpot)
    const cells = indicies.map((i) => this.puzzle[i[1]][i[0]])
    return cells.every((cell) => cell.length === 1)
  }

  shouldSolve (solvingSpot: number): boolean {
    const noSolves = this.noAutos.map((a) => a - 18)
    return !noSolves.includes(solvingSpot)
  }
}
